import gql from "graphql-tag";
import ATTENDANCE_FRAGMENT from "@/graphql/fragments/attendance";

export default gql`
  query attendancesByDate($dayOfAttendance: String!, $employeeId: ID, $patientName: String){
    attendancesByDate(dayOfAttendance: $dayOfAttendance, employeeId: $employeeId, patientName: $patientName) {
      ...attendanceParts
    }
  }
  ${ATTENDANCE_FRAGMENT}
`;
